import { TableColumn } from '@silverfort/sf-components';
import { SubUserRow, UserRow } from './types';
import {
    EmailCell,
    LastSeenCell,
    ManageCell,
    NameCell,
    StatusCell,
    SubUserManageCell,
    SubUserNameCell,
    SubUsersTableGroupCell,
    TokensCell
} from './components';

export const getTableColumns = (pageCount: number, total: number): TableColumn<UserRow>[] => {
    return [
        {
            columnKey: 'name',
            title: `Name (${pageCount.toLocaleString()} / ${total.toLocaleString()})`,
            render: NameCell
        },
        {
            columnKey: 'status',
            title: 'Status',
            render: StatusCell
        },
        {
            columnKey: 'email',
            title: 'Email',
            render: EmailCell
        },
        {
            columnKey: 'domain',
            title: 'Domain'
        },
        {
            columnKey: 'tokens',
            title: 'Tokens',
            render: TokensCell,
            columnClassName: '[&]:w-[184px]'
        },
        {
            columnKey: 'manage',
            title: '',
            render: ManageCell,
            columnClassName: '[&]:w-12 [&]:min-w-12 [&]:pr-0'
        }
    ];
};

export const SUB_USERS_TABLE_COLUMNS: TableColumn<SubUserRow>[] = [
    {
        columnKey: 'name',
        title: 'Name',
        render: SubUserNameCell
    },
    {
        columnKey: 'email',
        title: 'Email',
        render: EmailCell
    },
    {
        columnKey: 'groups',
        title: 'Groups',
        render: SubUsersTableGroupCell
    },
    {
        columnKey: 'lastSeen',
        title: 'Last seen',
        render: LastSeenCell
    },
    {
        columnKey: 'manage',
        title: '',
        render: SubUserManageCell,
        columnClassName: '[&]:w-12 [&]:min-w-12 [&]:pr-0 invisible group-hover:visible'
    }
];
